import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
  const { user } = useAuth();
  const [cart, setCart] = useState({ items: [], subtotal: 0 });
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!user) { setCart({ items: [], subtotal: 0 }); return; }
    setLoading(true);
    try {
      const { data } = await api.get("/cart");
      setCart(data);
    } finally { setLoading(false); }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const add = async (product_id, quantity = 1) => {
    await api.post("/cart/add", { product_id, quantity });
    await refresh();
  };
  const update = async (product_id, quantity) => {
    await api.post("/cart/update", { product_id, quantity });
    await refresh();
  };
  const remove = async (product_id) => {
    await api.delete(`/cart/${product_id}`);
    await refresh();
  };

  const count = cart.items.reduce((s, i) => s + (i.quantity || 0), 0);

  return (
    <CartContext.Provider value={{ cart, refresh, add, update, remove, count, loading }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
